var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIceSkating = function SvgIceSkating(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 19,
    fill: "none",
    viewBox: "0 0 21 19"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.25 18.75v-1.5h4v-2.5h-3V.25h8.5V4.5q0 .755.456 1.371.456.615 1.202.82l2.625.724q1.194.329 1.956 1.324.76.996.761 2.262v3.749h-3v2.5H16q1.346 0 2.26-.827.913-.826.99-2.173h1.5q-.077 1.97-1.429 3.235Q17.97 18.75 16 18.75zm2.5-5.5h12.5v-2.251q0-.76-.46-1.34a2.34 2.34 0 0 0-1.198-.8l-2.625-.75a3.9 3.9 0 0 1-1.474-.81 3.5 3.5 0 0 1-.953-1.357H6.5a.42.42 0 0 1-.31-.133.42.42 0 0 1-.132-.309q0-.177.133-.31a.42.42 0 0 1 .309-.132h1.84a5 5 0 0 1-.062-.534l-.028-.582H6.5a.42.42 0 0 1-.31-.133.42.42 0 0 1-.132-.309q0-.177.133-.31a.42.42 0 0 1 .309-.132h1.75V1.75h-5.5zm3 4h6.5v-2.5h-6.5z"
  })));
};
export default SvgIceSkating;